/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { clearLoginData } from '../../store/slices/api/auth/loginSlice';
import { useNavigate } from 'react-router-dom';

export default function LogoutPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const logout = () => {
        dispatch(clearLoginData());
        localStorage.clear();
        navigate('/');
    };

    useEffect(() => {
        logout();
    }, [])
    return (
        <div>logging you out...Please wait</div>
    )
}
